<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container
					*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.isLoading)) as $disabled"
				>
					<button
						mat-raised-button
						class="has-click-handler"
						color="basic"
						(click)="handler_ButtonBlock_4_click_loadAndOpen_0($event, {  })"
						[disabled]="$disabled"
					>
						<mat-icon>{{screen.isLoading ? 'pending' : 'receipt'}}</mat-icon
						><span
							[innerHtml]="!screen.isLoading ? 'Open receipt' : 'Loading...' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span>
					</button>
				</ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
